import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { UnauthorizedLayout, useAuth, userContext } from '../src/components/Auth';
import { Home } from './components/Home/Home';
import { LocationMap } from './components/Main/Layouts/Locations/LocationMap';

const App = () => {
  const { initializing, user } = useAuth()
  const queryClient = new QueryClient(
    {
      defaultOptions: {
        queries: {
          staleTime: Infinity,
        }
      }
    }
  )

  if (initializing) { //still setting state,  user is undefined
    return (
      <div class="ghost-creativ-map-wrapper" id="ghost-creativ-map-wrapper" style={{marginTop:20, textAlign:'center'}}>
          "Loading Location Data..."
      </div>
    )
  } else {
    return (
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {user === null ?
            <Routes>
              <Route path='auth/' element={<UnauthorizedLayout />} />
              <Route path='/locationMap' element={<LocationMap />} />
            </Routes>
            :
            <userContext.Provider value={{ user }}>
              <Routes>
                <Route path='/*' element={<Home />} />
                <Route path='/locationMap' element={<LocationMap />} />
              </Routes>
            </userContext.Provider>
          }
        </BrowserRouter >
      </QueryClientProvider>

    )
  }
}

export default App;